<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Chiffrement </div>
        <div class="modal-body">
            <div class="explain" *ngIf="fussionOrUnfusion === fussionOrUnfusionTpl.FUSION">
                <p>Vous avez choisi de fusionner les dossiers des patient<br><strong>{{ sourcePatient.nomNaissance }} {{ sourcePatient.prenom }}</strong> et <strong>{{ targetPatient.nomNaissance }} {{ targetPatient.prenom }}</strong></p>
                
                <p>Lorsque la fusion sera terminée, vous allez télécharger un fichier<br>comprennant l'intégralité des données nécessaires à une éventuelle défusion.</p>
                
                <p>Devant la sensibilité de ces données, ce fichier doit être <strong>chiffré</strong><br>par un mot de passe (appelé "phrase de chiffrement").</p>
                
                <p>Vous devez donc saisir un mot de passe et <strong>ne pas l'oublier</strong> car<br>il sera <strong>indispensable si une défusion devait être appliquée</strong>.</p>

                <p>Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule,<br>une lettre minuscule, un chiffre et un caractère spécial (tel que !@#$%^&*).</p>
            </div>

            <div class="explain" *ngIf="fussionOrUnfusion === fussionOrUnfusionTpl.UNFUSION">
                <p>Veuillez indiquer la phrase de chiffrement utilisée lors de la génération de ce fichier.</p>
            </div>

            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <frg-form-input label="Phrase de chiffrement" id="passphrase" type="text" [formGroup]="formGroup"
                    [control]="formGroup.get('passphrase')" [errorMessage]="passphraseErrorMessage">
                </frg-form-input>
                <div class="passphraseError" [ngClass]="{'error': isPassphraseError, 'no-error': isPassphraseNoError}">Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule,<br>un chiffre et un caractère spécial (tel que !@#$%^&*).</div>
                <div class="button-wrapper">
                    <frg-button (activated)="cancel()" [backgroundColor]="'var(--darkest-primary)'">Annuler</frg-button>
                    <frg-button [type]="'submit'" [backgroundColor]="'var(--primary)'">Valider</frg-button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>
